export default __webpack_public_path__ + "static/media/Corsairs-treasure-00.577e7675.png";